import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { Denomination } from 'ts/types/Denomination'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import DenominationAddPage from './DenominationAddPage'

const columns: Column<Denomination>[] = [
  {
    Header: 'ID',
    accessor: 'denominationId'
  },
  {
    Header: 'Active',
    accessor: 'flActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Denomination Name',
    accessor: 'denominationName'
  },
  {
    Header: 'Value',
    accessor: 'value'
  },
  {
    Header: 'Currency',
    accessor: 'currencyName'
  },
  {
    Header: 'ISO Code',
    accessor: 'isoCurrencyCode'
  },
  {
    Header: 'Notes?',
    accessor: 'flNote',
    Cell: ({ value }) => <BooleanCell value={value} />
  }
]

const DenominationPage = () =>{
  const Url = GetUrls();
  return (
    <CardTable
      columns={columns}
      dataKey={Url.getDenominations.toString()}
      url={Url.getDenominations}
      modalChild={<DenominationAddPage />}
    />
  )
} 

export default DenominationPage
